"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const quadrantsData = [{
  id: "public-sector-finance",
  heading: "Public Sector Finance",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580361/img/gov_erp_finance.png",
  buttonText: "Explore Solutions",
  linkTo: "/HomePage"
}, {
  id: "strategic-administration",
  heading: "Strategic Administration",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580361/img/gov_erp_admin.png",
  buttonText: "View Platform",
  linkTo: "/HomePage"
}];
export default function Quadrants() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section data-section-id="159319" id="v2" className="bg-background py-20 md:py-24 text-foreground">
      <div className="container mx-auto max-w-[1200px] px-4 md:px-6">
        <div ref={ref} className={`grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-8 transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          {quadrantsData.map((quadrant, i) => <div data-index={i} key={quadrant.id} className="h-full">
              <Card className="group relative flex min-h-[400px] md:min-h-[480px] flex-col items-center justify-center overflow-hidden rounded-lg border border-border p-8 text-center shadow-md transition-shadow duration-300 hover:shadow-xl">
                {}
                <img src={quadrant.image} alt={quadrant.heading} className="absolute inset-0 z-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                
                {}
                <div className="absolute inset-0 z-10 bg-primary/60 transition-colors duration-300 group-hover:bg-primary/70" />

                {}
                <div className="relative z-20 flex flex-col items-center gap-8">
                  <h3 className="text-3xl font-bold tracking-tight text-white md:text-4xl font-sans">
                    {quadrant.heading}
                  </h3>
                  
                  <Button asChild variant="secondary" size="lg" className="rounded-md bg-secondary px-8 py-6 text-sm font-bold uppercase tracking-wider text-secondary-foreground transition-all hover:bg-secondary/90 hover:shadow-lg">
                    <Link to={quadrant.linkTo}>
                      {quadrant.buttonText}
                    </Link>
                  </Button>
                </div>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}